<script src="https://raw.githubusercontent.com/DennisSuitters/summernote-cleaner/refs/heads/master/summernote-cleaner.js"></script>
<div *ngIf="showModal">
    <div class="modal-header">
        <h5 class="mb-0">HTML - {{ title | translate }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md d-flex flex-column gap-2" [formGroup]="form">
            <div class="mb-1 row">
                <input type="hidden" formControlName="id" />
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="language" class="col-form-label">{{ 'common.language' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="text" id="language" formControlName="language" class="form-control" />
                </div>
            </div>
            <hr />
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="key" class="col-form-label">{{ 'common.key' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="text" id="key" formControlName="key" class="form-control" />
                </div>
            </div>
            <div class="mt-2 d-flex flex-column flex-md-row align-items-start gap-2">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="value" class="col-form-label px-2">{{ 'common.value' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <textarea formControlName="value" id="summernote"></textarea>
                    <app-field-error-message controlName="value"></app-field-error-message>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="submit" [appClickWait]="onSave" class="btn btn-primary" themeColor="primary">
            {{ 'common.save' | translate }}
        </button>
        <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
    </div>
</div>
